import {TableContainerDefaultBox} from './table-container.default.box';
import {TableContainerBoxCasino777Box} from './table-container.casino777.box';
import {TableContainerBoxMrGreenBox} from './table-container.mrgreen.box';
import {styledByTheme} from '../../../../../../../../themes/architecture/styled-by-theme';

export const TableContainerBox = styledByTheme(TableContainerDefaultBox)
.forCasino777(TableContainerBoxCasino777Box)
.forMrGreen(TableContainerBoxMrGreenBox)
.apply();